import { useBreakpoint } from "@gigpro/ui/utils/useBreakpoint";
import { AiChatDock } from "domains/aiChat/components/AiChatDock";
import { useAskQwick } from "domains/aiChat/hooks/useAskQwick";
import { useOnTakeover } from "domains/aiChat/hooks/useOnTakeover";
import { dockBusyAtom } from "domains/aiChat/hooks/useOwnConversation";
import { useAtomValue, useSetAtom } from "jotai";
import { useFeatureFlag, useMarketplaceOverhaul } from "providers/LaunchDarkly";
import type React from "react";
import { agentChatSidebarAtom } from "services/atoms";

export const AgentChatShell = ({ children }: React.PropsWithChildren) => {
  const enabled = useFeatureFlag("agent-web-header-button-admin");
  // The takeover carries its own agent column; a second chat beside it would split the conversation.
  const onTakeover = useOnTakeover();
  // A turn in flight when the takeover opens finishes in the hidden dock, which mirrors it to the takeover's chat.
  const dockBusy = useAtomValue(dockBusyAtom);
  const sidebarNav = useMarketplaceOverhaul("navigation");
  const isDesktop = useBreakpoint("md");
  const setOpen = useSetAtom(agentChatSidebarAtom);
  const askQwick = useAskQwick(() => setOpen((prev) => !prev));

  if (!enabled) return children;
  return (
    <div className="flex">
      <div className="min-w-0 flex-1">{children}</div>
      {(!onTakeover || dockBusy) && (
        <div hidden={onTakeover} className={onTakeover ? undefined : "contents"}>
          <AiChatDock onOpenShell={sidebarNav && isDesktop ? askQwick.onClick : undefined} />
        </div>
      )}
    </div>
  );
};
